import React from 'react';
import ReactDOM from 'react-dom';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import './index.css';
import App from './App';
import Azure from './components/Azure';
import Login from './components/Login';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

// import * as serviceWorker from './serviceWorker';

// disableReactDevTools();

msalConfig.auth.redirectUri = document.location.toString().replace(/#.*/,'');

const msalInstance = new PublicClientApplication(msalConfig);
console.log( 'msalInstance', msalInstance, document.location.toString() )
ReactDOM.render(
  <React.StrictMode>
        <MsalProvider instance={msalInstance}>
        <App />
        <Azure />
        </MsalProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
